import React from 'react'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Modal, Box, IconButton, TextareaAutosize, Grid } from '@mui/material';
import FileUploadBox from '../../../../components/Projects/project-components/FileUploadBox';
const ImportPop = ({ openImportDataPop, handleCloseImportDataPop }) => {

    const modalMoveActivities = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '586px',
        width: '90%',
        margin: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: '2px',
        // border: '2px solid #0B57D0'
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        borderRadius: '12px',
    };


    return (
        <>

            <Modal open={openImportDataPop} fullWidth maxWidth="sm">
                <Box sx={{
                    ...modalMoveActivities,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                        <Box>
                            <Typography variant="h6" fontSize={'17px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Import balances</Typography>
                        </Box>
                        <IconButton onClick={handleCloseImportDataPop} className='p-0'>
                            <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </IconButton>
                    </Box>
                    {/* End Header */}

                    {/* start Body sec  */}
                    <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                        <Box>
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <FileUploadBox />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope', marginBottom: '5px' }}>Reason*</Typography>
                                        <TextareaAutosize className='textareclass'
                                            placeholder="Enter the reason you are adjusting the balance"
                                            style={{ width: '100%', borderRadius: '5px', height: '120px' , }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                    {/* End Body sec  */}

                    {/* start Footer sec  */}
                    <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                        <Button onClick={handleCloseImportDataPop} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Cancel
                        </Button>
                        <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                            <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow: 'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                    {/* End Footer sec  */}
                </Box>
            </Modal>
        </>
    )
}

export default ImportPop